
export default {
    name: "BlogAuthorSidebarLayout",
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            strapiData: []
        };
    },
    computed: {},
    methods: {
    },
}
